module.exports = __webpack_public_path__ + "media/images/common/lp/img-present-amazon-gift-9130b0026bb1631d39a86d7910b1d318.png";